import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DEBOUNCE_DELAY } from "../../../pages/Annuaire/constant";
import { AVATAR_DEFAULT } from "../../../constants";
import { debounce } from "../../../utils/global";
import { useQuerySearchEmployee } from "../api/queries";

const useGlobalSearchEmployee = () => {
    const navigate = useNavigate();

    const [users, setUsers] = useState(""); // chaine tapé par l'utilisateur
    const [items, setItems] = useState([]); // liste de tous les utilisateurs
    const [refresh, setRefresh] = useState(null);

    const { all_users, isFetching, isLoading } = useQuerySearchEmployee({
        users,
        onSuccess: () => {
            return setRefresh(new Date().getTime());
        },
    });

    // update Search input
    const handleChange = debounce((e) => {
        if (e?.target?.value?.length <= 2) {
            return;
        } else {
            setUsers(e.target.value);
        }
        return;
    }, DEBOUNCE_DELAY);

    // on click item dropdown
    const onClickItem = (e, data) => {
        if (data?.value?.id) {
            navigate(`/employee/${data.value.id}`);
        }
    };

    useEffect(() => {
        if (all_users) {
            const data = all_users?.map((el) => {
                return {
                    header: el?.first_name + " " + el?.last_name,
                    image: el?.avatar || AVATAR_DEFAULT,
                    content: el?.job_title || "/",
                    id: el?.id,
                    key: el?.id,
                };
            });
            setItems(data ?? []);
        }
    }, [refresh]);

    return {
        states: {
            users,
            setUsers,
            items,
            setItems,
            refresh,
            setRefresh,
        },
        query: {
            all_users,
            isLoading,
            isFetching,
        },
        functions: {
            handleChange,
            onClickItem,
        },
    };
};

export default useGlobalSearchEmployee;
